export default __webpack_public_path__ + "static/1-e5444f6c2e171231421e32b8fd61bf4a.webp";